module.exports = __webpack_public_path__ + "static/media/homeDecorScreenshot.1128e4f9.jpg";